import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { QuestionDTO, RechercheQuestionsDTO, ReponseSatisfactionDTO, SatisfactionDTO } from '@/models/Satisfaction';

class SatisfactionService {

    public async getSatisfactionConditions(): Promise<SatisfactionDTO> {
        const response = await http.get<SatisfactionDTO>(Routes.SatisfactionRoutes.RecupererDerniereSatisfaction());
        return response.data;
    }

    public async getQuestions(params: RechercheQuestionsDTO): Promise<QuestionDTO[]> {
        const response = await http.get<QuestionDTO[]>(Routes.SatisfactionRoutes.GetQuestions(), {
            params,
        });
        return response.data.map(question => {
            if (question.options && Array.isArray(question.options)) {
                question.options = question.options.filter(option => option.id && option.libelle);
            }
            return question;
        });
    }

    public async submitResponses(submissionData: {
        note: number;
        compteId: number | null;
        dateSaisie: string;
        reponses: ReponseSatisfactionDTO[]
        societeId: number;
    }): Promise<void> {
        await http.post(Routes.SatisfactionRoutes.SubmitResponses(), submissionData);
    }

    public async updateSatisfaction(satisfactionDTO: SatisfactionDTO): Promise<void> {
        await http.put(Routes.SatisfactionRoutes.UpdateSatisfaction(), satisfactionDTO);
    }

    public async plusTardClickCount(clickData: { clickCount: number; compteId: number, dateRepondrePlusTard: string }): Promise<void> {
        await http.post(Routes.SatisfactionRoutes.RepondrePlusTardClickCount(), clickData);
    }

    public async getClickCount(compteId: number): Promise<any> {
        return await http.get(`${Routes.SatisfactionRoutes.GetClickCount()}/${compteId}`);
    }

    public async modalGestionOptions(data: {
        compteId: number | null;
        dateRepondrePlusTard: string | null;
        dateNePlusAfficher: string | null;
        option: string
    }): Promise<void> {
        await http.post(Routes.SatisfactionRoutes.ModalGestionOptions(), data);
    }

}

export default new SatisfactionService();

